import { FilterConverter } from 'App/utils/FilterConverter';
import { SentryApiClient } from '_generated/api';

const siteFilterMap = new FilterConverter<
  SentryApiClient.SiteDTO,
  SentryApiClient.SiteFilters
>({ name: SentryApiClient.SiteFilters.Name });

export { siteFilterMap };
